/** v90 uppercase field labels on auth form screens. */
export const fieldLabelStyle = { textTransform: 'uppercase', letterSpacing: '0.08em' } as const;

/** v90 helper copy under inputs — 11px / 1.55 in prototype. */
export const fieldHintStyle = { lineHeight: 1.55 } as const;
